import { IAuthPayload } from '@kattana-io/common';
import { action } from 'typesafe-actions';

const entity = 'auth';

export interface SetAuthPayload {
  loggedIn: boolean;
  authFailed?: boolean;
  signature?: string;
  sessionId?: number;
  wallet?: string;
  network?: string;
  expires_at?: number;
}

const AUTH = `${entity}/AUTH`;
const SET_AUTH = `${entity}/SET_AUTH`;
const LOG_OUT = `${entity}/LOG_OUT`;

const actionAuth = (payload: IAuthPayload) => action(AUTH, payload);
const actionSetAuth = (payload: SetAuthPayload) => action(SET_AUTH, payload);
const actionLogOut = () => action(LOG_OUT);

export { AUTH, SET_AUTH, LOG_OUT, actionAuth, actionSetAuth, actionLogOut };
